// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-card {
  border-radius: 8px;
  padding: 15px;
}
.mini-card .text-title {
  font-weight: 500;
  font-size: 0.8rem;
  margin-bottom: 10px;
}
.mini-card .card-content {
  display: flex;
  justify-content: space-between;
}
.mini-card .card-content .text-subtitle, .mini-card .card-content .text-value {
  font-style: normal;
  font-weight: 600;
  font-size: 1.1rem;
  line-height: 25px;
}
.mini-card .card-content .icon-img {
  font-size: 25px;
  background: red;
  border-radius: 116px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
